<template>
  <div class="member-area-tab-login-config-component">
    <div class="my-3">
      Imagens do Login
    </div>
    <small class="text-secondary d-block mb-6">
      Personalize as imagens da sua área de Login
    </small>

    <div class="d-none d-lg-block">
      <div class="fs-14 my-3">Identificação da marca</div>
      <div class="row p-5 mb-5 mt-6 ml-0">
        <input-image
          v-model="form.brand"
          id="brand-image"
          title="Identificação de marca"
          description="Por padrão, utilizamos o nome da sua Área de Membros."
          class="col-lg-6"
          dimensions="600x128px"
        />
        <brand-mockup :image="form.brand" class="col-lg-6" />
      </div>
      <hr class=".hr" />
      <div class="fs-14 my-3">Apresentação</div>
      <div class="row p-5 my-5 ml-0">
        <input-image
          id="background-image"
          v-model="form.background"
          title="Imagem de apresentação"
          description="Utilize fotos que se encaixem no contexto ou crie uma imagem costumizada."
          class="col-lg-6"
          dimensions="1280x1224px"
        />
        <background-mockup :image="form.background" class="col-lg-6" />
      </div>
      <hr />
      <div class="fs-14 my-3">Logotipo</div>
      <div class="row p-5 my-5 ml-0">
        <input-image
          v-model="form.logo"
          id="logo-image"
          title="Logotipo"
          description="Utilize uma versão horizontal e fundo transparente para melhor visualização."
          class="col-lg-6"
          dimensions="600x210px"
        />
        <logo-mockup :image="form.logo" class="col-lg-6" />
      </div>
    </div>

    <div class="d-lg-none pt-3">
      <div class="fs-14 my-3">Identificação da marca</div>
      <input-image
        id="brand-logo"
        v-model="form.brand"
        title="Identificação de marca"
        description="Por padrão utilizamos o nome da sua Área de Membros."
        class="mt-5 mb-6"
        dimensions="600x128px"
      />
      <div class="fs-14 my-3">Apresentação</div>
      <input-image
        id="bg-presentation"
        v-model="form.background"
        title="Imagem de apresentação"
        description="Utilize fotos que se encaixem no contexto ou crie uma imagem costumizada."
        class="mt-5 mb-6"
        dimensions="1280x1224px"
      />
      <div class="fs-14 my-3">Logotipo</div>
      <input-image
        id="login-logo"
        v-model="form.logo"
        title="Logotipo"
        description="Utilize uma versão horizontal e fundo transparente para melhor visualização."
        class="mt-5 mb-6"
        dimensions="600x210px"
      />
    </div>
  </div>
</template>
<script>
import BackgroundMockup from "@/components/product/member-area/setup/BackgroundMockup.vue";
import BrandMockup from "@/components/product/member-area/setup/BrandMockup.vue";
import LogoMockup from "@/components/product/member-area/setup/LogoMockup.vue";
export default {
  components: {
    BrandMockup,
    BackgroundMockup,
    LogoMockup
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
<style>
.member-area-tab-login-config-component {
  .hr {
    border-top: 1px solid #f0eff2 !important;
  }
}
</style>
